module.exports = __webpack_public_path__ + "img/icon2.fc415f9e.png";